import Animation from './animation.element.js';

export default Animation;

Animation.define('wje-animation', Animation);
